module.exports = __webpack_public_path__ + "img/progress-2.c684b9e5.png";